/**
 * @flow
 */

const host = 'https://dailyqa-0.development.universe.engineer';
const widgets = 'https://widgets.dailyqa-0.development.universe.engineer';

export default {
  api: {
    base: `${host}/api/v2`,
    host,
  },
  basename: '/embed2',
  debug: true,
  environment: 'staging',
  explore: `${host}/explore`,
  googleTagManager: {
    gtmId: ''
  },
  amplitude: {
    api_key: '6dff3aa1ddb0eedffcc73805cd59a65a',
  },
  juno: `${host}/embed2`,
  betaCalendar: `${widgets}/calendar`,
  betaCheckout: `${widgets}`,
  calendar: 'https://redirect.dailyqa-0.development.universe.engineer/redirect',
  tickets: 'https://redirect.dailyqa-0.development.universe.engineer/redirect',
  checkout: 'https://redirect.dailyqa-0.development.universe.engineer/redirect',
  listings: 'https://redirect.dailyqa-0.development.universe.engineer/redirect',
  sift: 'bacdfbf377',
  oAuth: {
    url: `${host}/v2/oauth/token`
  },
  turnstile: {
    siteKeyManaged: '0x4AAAAAABGzdhvahJ2n-hPI',
    siteKeyInvisible: '0x4AAAAAABdXTbPbZYIX6XDw'
  },
  sentryDSN: 'https://7fa91119551e427ba955ae415f1731bf@app.getsentry.com/85720',
  visaCheckoutKey: 'O8ED5PQBX26DC3OFVPWC21msxfDrdf_IBCXgXPI1cDLE1cINM',
  visaCheckoutButton: 'https://sandbox.secure.checkout.visa.com/wallet-services-web/xo/button.png',
  visaCheckout: 'https://sandbox-assets.secure.checkout.visa.com',
  masterPass: 'https://sandbox.masterpass.com/switchui/index.html',
  masterPassCheckoutId: 'f47b2c83cd904fbe8eb80eb07c26f06b',
  masterPassJs: 'https://sandbox.masterpass.com/integration/merchant.js',
  universeLogo: 'https://cdn-assets-cloud.frontify.com/local/frontify/h_lNxVXLqrDqb2kyrixW3lMmUl7n-aBRzJUzyvzD7_9R_ZbVNQokieTtMAAhc7AOjJW2ZVOhdG_ZaFz1P73h5K_PuKvlHeLdvkGc7D-L2VZUndxhrXXrAmgvUSg48t7Z?width=2400',
  googleMapApiKey: 'AIzaSyD3q6LYn2E79CCBR1g_NG3NbdK8IFPN2g8',
  userEmailForMotoParamTest: 'andrew.barkman@universe.com'
};



// WEBPACK FOOTER //
// ./config/staging.js